import { httpClient } from '@/lib/http-client'

// 获取验证码
export const apiGetSmsCode = (data: { phone: string, type?: number }) => {
  return httpClient.post<ApiResponse<{ code: string }>>('/account/sms_code', data)
}

// 手机号登录
export const apiPhoneLogin = (data: { phone: string, code: string, invite_code?: string }) => {
  return httpClient.post<ApiResponse<{ token: string, user_id: number }>>('/account/phone_login', data)
}

// 获取邮箱验证码
export const apiGetEmailCode = (data: { email: string }) => {
  return httpClient.post<ApiResponse<{ success: boolean }>>('/account/email_code', data)
}

// 邮箱登录
export const apiEmailLogin = (data: { email: string, code: string }) => {
  return httpClient.post<ApiResponse<{ token: string, user_id: number }>>('/account/email_login', data)
}

// 工作室登录
export const apiStudioEnterLogin = (data: { jump_token: string, studio_id?: number }) => {
  return httpClient.post<ApiResponse< {
    user_id: number
    studio_id: number
    token: string
  } >>('/account/studio_enter_login', data)
}

// 退出登录
export const apiLogout = () => {
  return httpClient.post<ApiResponse<{ success: boolean }>>('/account/logout', {})
}
